const themeColors = {
	chartcolors: {
		robin: '#3F5ECC',
		dodgerBlue: '#2F80ED',
		mediumOrchid: '#BB6BD9',
		seaBuckthorn: '#F2994A',
		seaGreen: '#219653',
		turquoiseBlue: '#56CCF2',
		festivalOrange: '#F2C94C',
		silver: '#BDBDBD',
		outrageousOrange: '#FF6633',
		roseBud: '#FFB399',
		canary: '#FFFF99',
		deepSkyBlue: '#00B3E6',
		goldTips: '#E6B333',
		royalBlue: '#3366E6',
		avocado: '#999966',
		mintGreen: '#99FF99',
		chestnut: '#B34D4D',
		lima: '#80B300',
		olive: '#809900',
		beautyBush: '#E6B3B3',
		danube: '#6680B3',
		oliveDrab: '#66991A',
		lavenderRose: '#FF99E6',
		electricLime: '#CCFF1A',
		radicalRed: '#FF1A66',
		harleyOrange: '#E6331A',
		turquoise: '#33FFCC',
		gladeGreen: '#66994D',
		hemlock: '#66664D',
		vidaLoca: '#4D8000',
		rust: '#B33300',
		red: '#FF0000', // Adding more colors, we need to get better colors from design team
		blue: '#0000FF',
		green: '#00FF00',
		yellow: '#FFFF00',
		purple: '#800080',
		cyan: '#00FFFF',
		magenta: '#FF00FF',
		orange: '#FFA500',
		pink: '#FFC0CB',
		brown: '#A52A2A',
		teal: '#008080',
		lime: '#00FF00',
		maroon: '#800000',
		navy: '#000080',
		aquamarine: '#7FFFD4',
		gold: '#FFD700',
		gray: '#808080',
		skyBlue: '#87CEEB',
		indigo: '#4B0082',
		slateGray: '#708090',
		chocolate: '#D2691E',
		tomato: '#FF6347',
		steelBlue: '#4682B4',
		peru: '#CD853F',
		darkOliveGreen: '#556B2F',
		indianRed: '#CD5C5C',
		mediumSlateBlue: '#7B68EE',
		rosyBrown: '#BC8F8F',
		darkSlateGray: '#2F4F4F',
		mediumAquamarine: '#66CDAA',
		lavender: '#E6E6FA',
		thistle: '#D8BFD8',
		salmon: '#FA8072',
		darkSalmon: '#E9967A',
		paleVioletRed: '#DB7093',
		mediumPurple: '#9370DB',
		darkOrchid: '#9932CC',
		lawnGreen: '#7CFC00',
		mediumSeaGreen: '#3CB371',
		lightCoral: '#F08080',
		darkSeaGreen: '#8FBC8F',
		sandyBrown: '#F4A460',
		darkKhaki: '#BDB76B',
		cornflowerBlue: '#6495ED',
		mediumVioletRed: '#C71585',
		paleGreen: '#98FB98',
	},
	errorColor: '#d32f2f',
	royalGrey: '#888888',
	matterhornGrey: '#555555',
	whiteCream: '#ffffffd5',
	white: '#ffffff',
	black: '#000000',
	darkGrey: '#262626',
	lightBlack: '#141414',
	lightgrey: '#ddd',
	lightWhite: '#ffffffd9',
	borderLightGrey: '#d9d9d9',
	borderDarkGrey: '#424242',
	gainsboro: '#DBDBDB',
	navyBlue: '#1668DC',
	lightSkyBlue: '#8DCFF8',
	neroBlack: '#1d1d1d',
	snowWhite: '#fafafa',
	gamboge: '#D89614',
	bckgGrey: '#1d1d1d',
	lightBlue: '#177ddc',
	buttonSuccessRgb: '73, 170, 25',
	red: '#E84749',
};

export { themeColors };
